// import { dictionary } from "../dictionary";

import { dictionary } from "../dictionaries";

// export const translateKey = (key:string, lang:string) => {
// 	if(!dictionary[lang]){ return null; }
// 	let v = dictionary[lang][key];
// 	return v ? v : null;
// };

export const translateKey = (key:string, lang:string) => {
	const phrase = dictionary[key];
	if(!phrase){ return key; }
	return phrase[lang as ("en"|"is")] || `${key}.${lang}`;
};